import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from '../dataModel';
import { SingleSpecificationsWithKPF } from './SingleSpecificationsWithKPF';
import { MultiSpecificationsWithKPF } from './MultiSpecificationsWithKPF';
import { track } from '../specifications-analytics';
import { CONFIGURATOR_ITEM_IDS_EVENT, isEventBusCreated } from '../helpers';

export const SpecificationsWithKPFAccordionBodyComponent = (props) => {
  const {
    itemId,
    oneColumn,
    returnableStatus,
    isWhiteSpecTitle
  } = props;

  const [itemIds, setItemIds] = useState([itemId]);

  useEffect(() => {
    if (itemId) {
      setItemIds([itemId]);
    }
  }, [itemId]);

  useEffect(() => {
    if (isEventBusCreated()) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on(CONFIGURATOR_ITEM_IDS_EVENT, ({ output }) => {
        setItemIds(output.itemIds);
      });
    }
    return () => {
      if (isEventBusCreated()) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off(CONFIGURATOR_ITEM_IDS_EVENT);
      }
    };
  }, []);

  useEffect(() => { track('accordion-open'); }, []);

  if (!itemIds || itemIds.length === 0) {
    return null;
  }

  return (
    itemIds.length > 1
      ? <MultiSpecificationsWithKPF itemIds={itemIds} />
      : (
        <SingleSpecificationsWithKPF
          itemId={itemIds[0]}
          oneColumn={oneColumn}
          returnableStatus={returnableStatus}
          isWhiteSpecTitle={isWhiteSpecTitle}
        />
      )
  );
};

SpecificationsWithKPFAccordionBodyComponent.displayName = 'SpecificationsWithKPFAccordionBody';

SpecificationsWithKPFAccordionBodyComponent.dataModel = extend({}, dataModel, KeyProductFeatures);

const propTypes = {
  /** SKU Number */
  itemId: PropTypes.string.isRequired,
  returnableStatus: PropTypes.bool,
  oneColumn: PropTypes.bool,
  isWhiteSpecTitle: PropTypes.bool
};

const defaultProps = {
  oneColumn: false,
  returnableStatus: false,
  isWhiteSpecTitle: false
};

SpecificationsWithKPFAccordionBodyComponent.propTypes = propTypes;
SpecificationsWithKPFAccordionBodyComponent.defaultProps = defaultProps;

export const SpecificationsWithKPFAccordionBody = withErrorBoundary(SpecificationsWithKPFAccordionBodyComponent);

SpecificationsWithKPFAccordionBody.dataModel = extend({}, dataModel, KeyProductFeatures);
SpecificationsWithKPFAccordionBody.propTypes = propTypes;
SpecificationsWithKPFAccordionBody.defaultProps = defaultProps;
